<script>
import BaseModal from 'dashboard/components/dahreply/BaseModal.vue';
import { useAlert } from 'dashboard/composables';

export default {
  name: 'EditStaffColorModal',

  components: {
    BaseModal,
  },

  props: {
    staff: {
      type: Object,
      required: true,
    },
    currentColor: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      selectedColor: this.currentColor,
      isLoading: false,
    };
  },

  methods: {
    handleConfirm() {
      this.isLoading = true;

      this.$emit('save', this.staff.id, this.selectedColor);

      this.isLoading = false;
      useAlert('Staff color updated')
      this.$emit('close');
    },
  },
};
</script>

<template>
  <BaseModal @close="$emit('close')">
    <template #title>
      Edit Staff Color
    </template>

    <div class="space-y-4">
      <!-- Staff info -->
      <div>
        <p class="text-sm font-medium text-slate-900 dark:text-slate-100">
          {{ staff.name }}
        </p>
        <p class="text-xs text-slate-500 dark:text-slate-400">
          Choose a color used to display this staff’s assignments
        </p>
      </div>

      <!-- Color picker -->
      <div class="flex items-center gap-4">
        <input
          type="color"
          v-model="selectedColor"
          class="w-10 h-10 rounded border border-slate-300 dark:border-slate-600 cursor-pointer"
        />

        <div
          class="px-3 py-2 rounded text-sm border border-slate-200 dark:border-slate-700"
        >
          {{ selectedColor }}
        </div>
      </div>
    </div>

    <template #footer>
      <div class="flex justify-end gap-3 mt-4">
        <woot-button
          color-scheme="secondary"
          @click="$emit('close')"
          :disabled="isLoading"
        >
          Cancel
        </woot-button>

        <woot-button
          @click="handleConfirm"
          :loading="isLoading"
          :disabled="isLoading"
        >
          Update
        </woot-button>
      </div>
    </template>
  </BaseModal>
</template>